export default "/_next/static/chunks/fonts/WhitneySSm-Bold-Pro_Web-eb917ad8077e760968694b348e604e95.woff2";